var _circle, _circle2, _circle3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgThreeDotLoaderGradient = function SvgThreeDotLoaderGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 59.417,
    cy: 31.999,
    r: 3.917,
    fill: "url(#three-dot-loader-gradient_svg__a)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    dur: "1s",
    values: "59.4167;4.58366;4.58366",
    keyTimes: "0;0.8;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 11.75,
    fill: "url(#three-dot-loader-gradient_svg__a)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    values: "1;0.5;0.5",
    keyTimes: "0;0.8;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    dur: "1s",
    values: "32;59.4167;59.4167",
    keyTimes: "0;0.8;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    dur: "1s",
    values: "11.75;3.91667;3.91667",
    keyTimes: "0;0.8;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 4.584,
    cy: 31.999,
    r: 3.917,
    fill: "url(#three-dot-loader-gradient_svg__a)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    values: "0.5;1;1",
    keyTimes: "0;0.8;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    dur: "1s",
    values: "4.58366;32;32",
    keyTimes: "0;0.8;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    dur: "1s",
    values: "3.91667;11.75;11.75",
    keyTimes: "0;0.8;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline",
    repeatCount: "indefinite"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "three-dot-loader-gradient_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "16%",
    stopColor: "#4664FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "90%",
    stopColor: "#41D9F1"
  })))));
};

export default SvgThreeDotLoaderGradient;